export function isChunkFullEntry(x) {
    return x.entries !== undefined;
}
export function isFullEntryLoadChunkResponse(x) {
    return x.fullEntries !== undefined;
}
